import { Service } from "@roc/feature-app-core";

const url = {
  UPLOAD_LEADS: "/api/v1/lender/uploadLead/uploadLeadFile",
  GET_TEMPLATE: "/api/v1/lender/uploadLead/getUploadLeadsTemplate",
  GET_ALL_UPLOAD_EVENTS: "/api/v1/lender/uploadLead/getAllUploadEvents",
  GET_FILE_META_DATA: "/api/v1/lender/uploadLead/getFileMetadata",
};

export class UploadLeadsService extends Service {
  getTemplate() {
    return this.get(url.GET_TEMPLATE, null, {
      responseType: "arraybuffer",
    });
  }

  uploadLeadsFile(file, name, brand, eventPlace, owners) {
    const formData = new FormData();
    owners.forEach((ownerId) => formData.append("ownerIds", ownerId));
    formData.append("file", file);
    formData.append("name", name);
    formData.append("brand", brand);
    formData.append("eventPlace", eventPlace);

    return this.post(url.UPLOAD_LEADS, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  getAllUploadEvents(filters, page, pageSize, sortBy, sortDir) {
    const params = {
      filters,
      page,
      pageSize,
      sortBy,
      sortDir,
    };
    return this.get(url.GET_ALL_UPLOAD_EVENTS, params);
  }

  getFileMetaData(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    return this.post(url.GET_FILE_META_DATA, formData);
  }

}
